import { render, staticRenderFns } from "./welfarePc.vue?vue&type=template&id=71740488&scoped=true&"
import script from "./welfarePc.vue?vue&type=script&lang=js&"
export * from "./welfarePc.vue?vue&type=script&lang=js&"
import style0 from "./welfarePc.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./welfarePc.vue?vue&type=style&index=1&id=71740488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71740488",
  null
  
)

export default component.exports